import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Navbar } from '../components/Navbar';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { Truck, Search, ExternalLink } from 'lucide-react';

const TrackingPage = () => {
  const [searchParams] = useSearchParams();
  const initialCode = searchParams.get('code') || '';
  const [trackingCode, setTrackingCode] = useState(initialCode);
  const [submitted, setSubmitted] = useState(!!initialCode);

  const truck17Url = `https://t.17track.net/en#nums=${encodeURIComponent(trackingCode)}`;

  const handleSubmit = (e) => {
    e.preventDefault();
    if (trackingCode.trim()) setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-[#030014]" data-testid="tracking-page">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 pt-28 pb-16">
        <div className="text-center mb-8">
          <Truck className="w-12 h-12 text-[#8B5CF6] mx-auto mb-4" />
          <h1 className="text-3xl font-bold">Track Your Order</h1>
          <p className="text-gray-400 mt-2">Enter your tracking code to see delivery status</p>
        </div>

        <form onSubmit={handleSubmit} className="flex gap-3 max-w-lg mx-auto mb-8" data-testid="tracking-form">
          <Input
            value={trackingCode}
            onChange={e => { setTrackingCode(e.target.value); setSubmitted(false); }}
            placeholder="Enter tracking code..."
            className="flex-1"
            data-testid="tracking-input"
          />
          <Button type="submit" className="bg-[#8B5CF6] hover:bg-[#7C3AED]" data-testid="tracking-search-btn">
            <Search className="w-4 h-4 mr-2" /> Track
          </Button>
        </form>

        {submitted && trackingCode.trim() && (
          <div className="admin-card overflow-hidden" data-testid="tracking-result">
            <div className="p-4 border-b border-white/10 flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-400">Tracking Code</p>
                <p className="font-mono font-bold text-lg">{trackingCode}</p>
              </div>
              <a href={truck17Url} target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-[#8B5CF6] hover:text-[#7C3AED] text-sm">
                Open in 17TRACK <ExternalLink className="w-4 h-4" />
              </a>
            </div>
            <iframe
              src={truck17Url}
              title="Tracking"
              className="w-full border-0"
              style={{ height: '600px' }}
              sandbox="allow-scripts allow-same-origin allow-popups"
              data-testid="tracking-iframe"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackingPage;
